import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

export default class TemplateDocCompatibleTagsEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    TemplateDocCompatibleTagsEditing.elementsInTemplateDocuments.forEach(
      (element) => {
        schema.register(element, {
          allowWhere: "$block",
          allowContentOf: "$root",
        });

        editor.conversion.for("upcast").elementToElement({
          view: element,
          model: (viewElement, { writer: modelWriter }) => {
            return modelWriter.createElement(
              element,
              viewElement.getAttributes()
            );
          },
        });

        editor.conversion
          .for("downcast")
          .elementToElement({ model: element, view: element });
      }
    );
  }
}

TemplateDocCompatibleTagsEditing.elementsInTemplateDocuments = [
  "section",
  "div",
  "header"
];
